import { Link } from "react-router-dom";
import type { Movie } from "@/utils/movies";
import { formatViews } from "@/utils/movies";

interface MovieCardProps {
  movie: Movie;
  showSummary?: boolean;
}

export default function MovieCard({ movie, showSummary = true }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      data-product-shop
      className="group block bg-background-100 border border-background-200/60 rounded-lg overflow-hidden transition-all duration-300 hover:border-primary-500/60 hover:-translate-y-1"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 影视封面`}
          title={`${movie.title} 影视内容`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2 flex items-center gap-1 bg-background-50/85 backdrop-blur px-2 py-1 rounded-md">
          <i className="ri-star-fill text-accent-500 text-xs" />
          <span className="text-xs font-semibold text-foreground-50">{movie.rating.toFixed(1)}</span>
        </div>
        <div className="absolute top-2 right-2 bg-primary-500 text-background-50 text-[11px] px-2 py-1 rounded-md whitespace-nowrap">
          {movie.type}
        </div>

        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-3">
          <p className="text-xs text-foreground-200 leading-relaxed line-clamp-3">{movie.summary}</p>
        </div>
      </div>

      <div className="p-3">
        <h3 className="text-sm md:text-base font-semibold text-foreground-50 line-clamp-1 group-hover:text-accent-500 transition-colors">
          {movie.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1.5 line-clamp-1">
          {movie.region} · {movie.year} · {movie.genres.slice(0, 2).join(" / ")}
        </p>
        <div className="flex items-center justify-between mt-2.5">
          <span className="text-xs text-primary-400 line-clamp-1">{movie.status}</span>
          <span className="flex items-center gap-1 text-xs text-foreground-500 shrink-0">
            <i className="ri-eye-line" />
            {formatViews(movie.views)}
          </span>
        </div>
        {showSummary && (
          <p className="hidden sm:block text-xs text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
            {movie.summary}
          </p>
        )}
      </div>
    </Link>
  );
}